// @ts-nocheck
import type { Question } from '../types';

export const riskAwarenessQuestions: Question[] = [
  {
    id: 'q-ra-1',
    topic: 'General',
    question: 'What is the main purpose of keeping a safe following distance?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-1-safe-following-distance.jpg',
    options: [
      { id: 'q-ra-1o1', text: 'To save fuel' },
      { id: 'q-ra-1o2', text: 'To have time and space to stop or avoid a hazard' },
      { id: 'q-ra-1o3', text: 'To allow others to overtake' }
    ],
    answerId: 'q-ra-1o2',
    explanation: 'A safe following distance gives you time to react and stop or avoid a hazard if the vehicle in front brakes suddenly. (RVV 1990 art. 19)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-2',
    topic: 'General',
    question: 'You are approaching a blind bend. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-2-blind-bend-approach.jpg',
    options: [
      { id: 'q-ra-2o1', text: 'Maintain speed; you have right of way' },
      { id: 'q-ra-2o2', text: 'Slow down and be prepared for hazards you cannot see' },
      { id: 'q-ra-2o3', text: 'Sound your horn and maintain speed' }
    ],
    answerId: 'q-ra-2o2',
    explanation: 'On a blind bend you cannot see what is ahead. Slow down and be prepared to stop or avoid obstacles, pedestrians, or oncoming traffic.',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-3',
    topic: 'General',
    question: 'Why should you check your blind spot before changing lanes?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-3-blind-spot.jpg',
    options: [
      { id: 'q-ra-3o1', text: 'It is required by law only on motorways' },
      { id: 'q-ra-3o2', text: 'Another vehicle or cyclist may be there and not visible in the mirror' },
      { id: 'q-ra-3o3', text: 'To reduce fuel consumption' }
    ],
    answerId: 'q-ra-3o2',
    explanation: 'The blind spot is an area not covered by mirrors. Checking it before changing lanes prevents collisions with vehicles or cyclists beside you.',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-4',
    topic: 'General',
    question: 'What is "defensive driving"?',
    options: [
      { id: 'q-ra-4o1', text: 'Driving slowly at all times' },
      { id: 'q-ra-4o2', text: 'Anticipating hazards and acting in good time to avoid danger' },
      { id: 'q-ra-4o3', text: 'Letting others go first always' }
    ],
    answerId: 'q-ra-4o2',
    explanation: 'Defensive driving means anticipating what might happen and adjusting your speed and position to avoid danger before it occurs.',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-5',
    topic: 'General',
    question: 'What is a Zone 30 area and how should you drive in it?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/zone30-child.jpg',
    options: [
      { id: 'q-ra-5o1', text: 'A motorway with maximum speed 30 km/h' },
      { id: 'q-ra-5o2', text: 'A residential area with 30 km/h speed limit where children and pedestrians are present; drive carefully and be prepared to stop' },
      { id: 'q-ra-5o3', text: 'A parking zone where you must park at 30-degree angles' }
    ],
    answerId: 'q-ra-5o2',
    explanation: 'Zone 30 areas are residential neighborhoods with 30 km/h speed limits. They have high child and pedestrian activity. Reduce speed, stay alert, and be prepared to stop immediately. (RVV 1990 art. 21)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-6',
    topic: 'General',
    question: 'What is a "safe stopping distance" made up of?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-6-safe-stopping-distance.jpg',
    options: [
      { id: 'q-ra-6o1', text: 'Only the distance your car travels while you brake' },
      { id: 'q-ra-6o2', text: 'Thinking distance plus braking distance' },
      { id: 'q-ra-6o3', text: 'Only the distance you can see ahead' }
    ],
    answerId: 'q-ra-6o2',
    explanation: 'Stopping distance = thinking distance (while you react) + braking distance (while the car stops). Both increase with speed.',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-7',
    topic: 'General',
    question: 'You are following a large lorry. Why should you keep a greater distance than usual?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-7-following-large-lorry.jpg',
    options: [
      { id: 'q-ra-7o1', text: 'To save fuel by slipstreaming' },
      { id: 'q-ra-7o2', text: 'You cannot see the road ahead; if it brakes hard you need more space to stop' },
      { id: 'q-ra-7o3', text: 'Lorries always brake suddenly' }
    ],
    answerId: 'q-ra-7o2',
    explanation: 'A large vehicle blocks your view of the road ahead. You need extra distance to see hazards and to stop safely if the lorry brakes. (RVV 1990 art. 19)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-8',
    topic: 'General',
    question: 'What should you do when you see a vehicle with hazard lights on stopped on the hard shoulder?',
    options: [
      { id: 'q-ra-8o1', text: 'Stop and offer help' },
      { id: 'q-ra-8o2', text: 'Slow down and move away from the hard shoulder if safe; be ready for people or debris' },
      { id: 'q-ra-8o3', text: 'Ignore it; it is not your concern' }
    ],
    answerId: 'q-ra-8o2',
    explanation: 'Pass with care. People may be on the carriageway; move away from the hard shoulder if safe and reduce speed.',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-9',
    topic: 'General',
    question: 'Why is it riskier to drive at the same speed in rain as in dry weather?',
    options: [
      { id: 'q-ra-9o1', text: 'Rain makes the engine work harder' },
      { id: 'q-ra-9o2', text: 'Stopping distance increases; grip is reduced' },
      { id: 'q-ra-9o3', text: 'Other drivers drive slower' }
    ],
    answerId: 'q-ra-9o2',
    explanation: 'Wet roads reduce grip. Your stopping distance increases, so you need to slow down and leave a larger gap. (RVV 1990 art. 10)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-10',
    topic: 'General',
    question: 'Why does increasing your speed significantly increase your stopping distance?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-10-speed-reaction-time.jpg',
    options: [
      { id: 'q-ra-10o1', text: 'Because the engine has to work harder' },
      { id: 'q-ra-10o2', text: 'Because your reaction time increases and your car has more momentum to lose' },
      { id: 'q-ra-10o3', text: 'Because other drivers go slower' }
    ],
    answerId: 'q-ra-10o2',
    explanation: 'At double speed, stopping distance is approximately 4x longer. Your reaction time stays the same, but the distance traveled during reaction increases, and momentum increases exponentially. (RVV 1990 art. 19)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-11',
    topic: 'General',
    question: 'When driving in fog, what is the main risk?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-11-visibility-bad-weather.jpg',
    options: [
      { id: 'q-ra-11o1', text: 'Your windscreen gets dirty' },
      { id: 'q-ra-11o2', text: 'Other drivers might have fog lights on' },
      { id: 'q-ra-11o3', text: 'Reduced visibility means you cannot see hazards until too late; large stopping distances needed' }
    ],
    answerId: 'q-ra-11o3',
    explanation: 'Fog severely reduces sight distance. You cannot see hazards, other vehicles, or pedestrians until too late. Reduce speed significantly and increase following distance. (RVV 1990 art. 10)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-12',
    topic: 'General',
    question: 'Why is night driving more risky than day driving?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-12-driving-at-night.jpg',
    options: [
      { id: 'q-ra-12o1', text: 'Street lights are always broken' },
      { id: 'q-ra-12o2', text: 'Reduced visibility makes hazard perception harder; headlights do not illuminate as far as you need' },
      { id: 'q-ra-12o3', text: 'Other cars have no lights' }
    ],
    answerId: 'q-ra-12o2',
    explanation: 'Your vision range at night is limited to your headlight distance. You have less time to react to hazards. Reduce speed and stay alert. (RVV 1990 art. 10)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-13',
    topic: 'General',
    question: 'What is the safest action if you become drowsy while driving?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-13-fatigue-warning.jpg',
    options: [
      { id: 'q-ra-13o1', text: 'Turn up the music and drive faster' },
      { id: 'q-ra-13o2', text: 'Open windows and continue driving' },
      { id: 'q-ra-13o3', text: 'Stop in a safe place and rest; fatigue impairs judgment like alcohol' }
    ],
    answerId: 'q-ra-13o3',
    explanation: 'Fatigue causes slow reactions, poor decision-making, and unintentional lane drifting. It can be as dangerous as driving under the influence. Take regular breaks and rest when tired. (RVV 1990 art. 2)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-14',
    topic: 'General',
    question: 'What does "reading the road" mean in defensive driving?',
    options: [
      { id: 'q-ra-14o1', text: 'Reading road signs only' },
      { id: 'q-ra-14o2', text: 'Anticipating potential hazards ahead (hidden pedestrians, other vehicles, weather) and adjusting position and speed' },
      { id: 'q-ra-14o3', text: 'Remembering the speed limit' }
    ],
    answerId: 'q-ra-14o2',
    explanation: 'Good defensive drivers anticipate what might happen and prepare to react before danger occurs. This includes observing road conditions, traffic patterns, pedestrians, and potential hazards ahead.',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-21',
    topic: 'General',
    question: 'When parking at a corner, what safety risk must you avoid?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-21-corner-visibility.jpg',
    options: [
      { id: 'q-ra-21o1', text: 'Blocking the view of road signs' },
      { id: 'q-ra-21o2', text: 'Reducing visibility for drivers; parked vehicles at corners create blind spots for turning traffic' },
      { id: 'q-ra-21o3', text: 'Taking up too much parking space' }
    ],
    answerId: 'q-ra-21o2',
    explanation: 'Never park too close to corners. Parked vehicles obstruct visibility for drivers trying to turn, increasing accident risk. Maintain clear sightlines at intersections and corners. (RVV 1990 art. 12)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-22',
    topic: 'General',
    question: 'What must you observe when parking in residential zones?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-22-residential-zone.jpg',
    options: [
      { id: 'q-ra-22o1', text: 'Park anywhere within the zone' },
      { id: 'q-ra-22o2', text: 'Park only in marked parking spaces and follow all local parking signs and regulations' },
      { id: 'q-ra-22o3', text: 'Parking is always prohibited in residential zones' }
    ],
    answerId: 'q-ra-22o2',
    explanation: 'In residential zones, you must park only in designated parking spaces and follow all posted parking signs and local regulations. Improper parking can result in fines and vehicle removal. (RVV 1990 art. 12)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-23',
    topic: 'General',
    question: 'What safety risk must you avoid when parking near tram tracks?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-23-tram-tracks.jpg',
    options: [
      { id: 'q-ra-23o1', text: 'Blocking tram access and interfering with tram operation' },
      { id: 'q-ra-23o2', text: 'Damaging the tram tracks' },
      { id: 'q-ra-23o3', text: 'There is no safety risk near tram tracks' }
    ],
    answerId: 'q-ra-23o1',
    explanation: 'Never park on or too close to tram tracks. Parked vehicles interfere with tram operation and create safety hazards for all road users. Parking violations near tram tracks can result in fines and vehicle removal. (RVV 1990 art. 12)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-24',
    topic: 'General',
    question: 'You are driving at 50 km/h on a priority road (voorrangsweg). A car at the give-way line on the right is partially hidden behind a hedge and inching forward. You have right of way — but what do you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/hp-scene-1.jpg',
    options: [
      { id: 'q-ra-24o1', text: 'Brake immediately' },
      { id: 'q-ra-24o2', text: 'Release accelerator' },
      { id: 'q-ra-24o3', text: 'Do nothing' }
    ],
    answerId: 'q-ra-24o2',
    explanation: 'You have priority, but that does not mean you can ignore the hazard. The hedge creates a blind spot — you cannot confirm the other driver has seen you or will yield. Release the accelerator to reduce speed and be ready to brake if the car pulls out. (RVV 1990 art. 45)',
    subject: 'Risk Awareness'
  },
  {
    id: 'q-ra-25',
    topic: 'General',
    question: 'You are driving at 50 km/h on a wet road. A cyclist is visibly unstable and drifting toward your lane. What is your response?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/hp-scene-4.jpg',
    options: [
      { id: 'q-ra-25o1', text: 'Brake immediately' },
      { id: 'q-ra-25o2', text: 'Release accelerator' },
      { id: 'q-ra-25o3', text: 'Do nothing' }
    ],
    answerId: 'q-ra-25o2',
    explanation: 'The cyclist is visibly unstable and drifting toward your lane on a wet road. Release the accelerator — this reduces speed without the skid risk of hard braking on a wet surface. Give the cyclist space and be ready to brake if they fully enter your lane. (RVV 1990 art. 10)',
    subject: 'Risk Awareness'
  }
];
